import { useEffect, useState } from 'react';
import { supabase } from '../lib/webSite';

const BUCKET = 'newsletters';

function publicUrl(filePath) {
  if (!supabase || !filePath) return '';
  const { data } = supabase.storage.from(BUCKET).getPublicUrl(filePath);
  return data?.publicUrl || '';
}

export default function useNewsletters() {
  const [issues, setIssues] = useState([]);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      if (!supabase) return;
      try {
        const { data, error } = await supabase
          .from('newsletters')
          .select('id, title, issue_label, file_path, file_name, sort_order')
          .order('sort_order', { ascending: true })
          .order('created_at', { ascending: false });

        if (error) throw error;
        if (cancelled) return;

        setIssues(
          (data || []).map((row) => ({
            id: row.id,
            title: row.title,
            label: row.issue_label || '',
            url: publicUrl(row.file_path),
            fileName: row.file_name,
          })),
        );
      } catch (err) {
        console.warn('Could not load newsletters.', err);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return issues;
}

export async function subscribeToNewsletter(email) {
  if (!supabase) throw new Error('Newsletter service unavailable');
  const cleaned = String(email || '').trim().toLowerCase();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cleaned)) {
    throw new Error('Enter a valid email address');
  }

  const { error } = await supabase.from('newsletter_subscribers').insert({
    email: cleaned,
  });

  if (error) {
    if (error.code === '23505') {
      throw new Error('This email is already subscribed');
    }
    throw error;
  }
}
